import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export type DigestRunStatus = 'running' | 'completed' | 'partial' | 'failed'
export type DigestRunTrigger = 'cron' | 'manual_replay' | 'test'

export type AdminRegulatoryDigestRun = {
  id: string
  cronFire: string
  startedAt: string
  finishedAt: string | null
  candidateUsersCount: number
  emailsSent: number
  usersSkippedNoEvents: number
  usersSkippedAlreadySent: number
  errorsCount: number
  status: DigestRunStatus
  trigger: DigestRunTrigger
}

export type AdminRegulatoryDigestRunsResponse = {
  runs: AdminRegulatoryDigestRun[]
}

export type ReplayDigestResponse = {
  runId: null
  queued: true
  jobId: string
}

const ADMIN_REGULATORY_DIGEST_RUNS_QUERY_KEY = ['admin-regulatory-digest-runs'] as const

export function useAdminRegulatoryDigestRuns() {
  return useQuery<AdminRegulatoryDigestRunsResponse>({
    queryKey: ADMIN_REGULATORY_DIGEST_RUNS_QUERY_KEY,
    queryFn: () => api.get<AdminRegulatoryDigestRunsResponse>('/admin/regulatory/digest-runs'),
    staleTime: 30_000,
  })
}

export function useReplayRegulatoryDigest() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () =>
      api.post<ReplayDigestResponse>('/admin/regulatory/digest-runs/replay', {
        trigger: 'manual_replay',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_REGULATORY_DIGEST_RUNS_QUERY_KEY })
    },
  })
}
